import { colors } from 'design-system';
import IconProps from './IconProps';
import VectorIcon from './VectorIcon';

const ShieldIcon = ({
  width = 24,
  height = 25,
  color = colors.madison,
}: IconProps): JSX.Element => (
  <VectorIcon width={width} height={height}>
    <path
      d="M22.5179 4.08706L13.1429 0.180811C12.8561 0.0587403 12.5492 
        0 12.2426 0C11.9359 0 11.6293 0.0583985 11.3412 0.180469L1.96667 
        4.08706C1.09363 4.44693 0.520874 5.30239 0.520874 6.20572C0.520874 
        18.818 9.76892 24.9997 12.2347 24.9997C14.642 24.9997 23.9584 18.9108 
        23.9584 6.20572C23.9584 5.30239 23.3871 4.44693 22.5179 4.08706ZM22.391 
        6.26431C22.391 17.2653 14.2758 23.4372 12.2445 23.4372C10.1547 23.3932 
        2.08337 17.1969 2.08337 6.24966C2.08337 5.93228 2.27258 5.65152 2.55945 
        5.52945L11.9344 1.62319C12.0308 1.58279 12.1351 1.56138 12.24 1.56138C12.3411 
        1.56138 12.4428 1.58126 12.5387 1.62319L21.9137 5.52945C22.3617 5.71743 22.391 
        6.14224 22.391 6.26431ZM16.1459 8.8522C15.946 8.8522 15.7461 8.92847 15.5936 
        9.08111L10.9359 13.7399L8.88513 11.6891C8.73376 11.5329 8.53357 11.4596 8.33337 
        11.4596C7.88713 11.4596 7.55212 11.8245 7.55212 12.2409C7.55212 12.4408 7.62839 
        12.6407 7.78103 12.7931L10.3855 15.3971C10.5404 15.5465 10.7406 15.6247 10.9359 
        15.6247C11.1312 15.6247 11.3357 15.5484 11.4882 15.3958L16.6981 10.1858C16.849 
        10.0338 16.9271 9.83365 16.9271 9.63345C16.9271 9.21841 16.5902 8.8522 16.1459 
        8.8522Z"
      fill={color}
    />
  </VectorIcon>
);

export default ShieldIcon;
